<template>
  <div class="selectStorageStyle">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
    >
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        start: '',
        end: ''
      })
    },
    height: { default: '32px' }
  },
  data: () => ({
    items: []
  }),
  created() {
    const tmp = this.getStockAdjustReasonListFromState()
    // API実行失敗
    if (!tmp) {
      return {}
    }
    this.items = tmp.map((ele) => {
      return { label: ele.name, value: ele.stockAdjustReasonId }
    })

    // this.inputedValue = tmp[0]
  },
  methods: {
    ...mapGetters('Common', ['getStockAdjustReasonListFromState'])
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectStorageStyle {
  width: 100%;
}
</style>
